import request from '@/axios'

export function quickBookOauthApi () {
  return request({
    url: 'quickbooks/get_auth_url',
    method: 'GET'
  })
}

export function getQuickBooksApi (payload) {
  return request({
    url: 'quickbooks/get_auth_token',
    method: 'POST',
    data:payload
  })
}